import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
// 3rd party
import { RxReactiveDynamicFormsModule } from "@rxweb/reactive-dynamic-forms";
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators";
// Modules
import { SharedModule } from "../../../shared/shared.module";
import { SvsRoutingModule } from "./svs-routing.module";
import { DataViewModule } from "primeng/dataview";
import { PickListModule } from "primeng/picklist";
import { ButtonModule } from "primeng/button";
import { ImageModule } from "primeng/image";
import { GalleriaModule } from "primeng/galleria";
import { InputSwitchModule } from "primeng/inputswitch";
import { TooltipModule } from "primeng/tooltip";
import { ChartsModule } from "ng2-charts";
// Services
import { FormService } from "../../../shared/services/form.service";
import { MediasService } from "../../../services/medias.service";
import { ReelsService } from "../../../services/reels.service";
import { GroupsService } from "../../../services/groups.service";
import { LayoutsService } from "../../../services/layouts.service";
// Components
import { PublicidadComponent } from "./publicidad/publicidad.component";
import { SvsEditCreateComponent } from "./publicidad/modal/edit-create/edit-create.component";
import { MediaComponent } from "./media/media.component";
import { EditCreateMediaComponent } from "./media/edit-create-media/edit-create-media.component";
import { ReelsComponent } from "./reels/reels.component";
import { CreateEditReelComponent } from "./reels/create-edit-reel/create-edit-reel.component";
import { ConfigMediasComponent } from "./reels/config-medias/config-medias.component";
import { GroupsComponent } from "./groups/groups.component";
import { UnitsComponent } from "./units/units.component";
import { EditCreateUnitsComponent } from "./units/edit-create-units/edit-create-units.component";
import { EditCreateGroupsComponent } from "./groups/edit-create-groups/edit-create-groups.component";
import { ConfigGroupsComponent } from "./groups/config-groups/config-groups.component";
import { ReelCategoriesComponent } from "./reel-categories/reel-categories.component";
import { CreateEditReelCategoryComponent } from "./reel-categories/create-edit-reel-category/create-edit-reel-category.component";
import { ShowVideoComponent } from "./media/show-video/show-video.component";
import { DialogService } from "primeng/dynamicdialog";
import { EvidencesComponent } from "./evidences/evidences.component";
import { PaginatorModule } from "primeng/paginator";
import { UnitEvidencesComponent } from "./units/unit-evidences/unit-evidences.component";
import { CalendarModule } from "primeng/calendar";
import { LayoutsComponent } from "./layouts/layouts.component";
import { CreateEditLayoutComponent } from "./layouts/create-edit-layout/create-edit-layout.component";
import { ImportReelComponent } from "./reels/import-reel/import-reel.component";
import { ExportReportComponent } from "./media/export-report/export-report.component";
import { UsersComponent } from "./users/users.component";
import { CreateEditUserComponent } from "./users/create-edit-user/create-edit-user.component";
import { FileUpload, FileUploadModule } from "primeng/fileupload";
import { ClientModalComponent } from "./units/client-modal/client-modal.component";
import { MediaKpiComponent } from "./media-kpi/media-kpi.component";
import { HerramientasComponent } from "./herramientas/herramientas.component";
import { ReportKpiComponent } from "./report-kpi/report-kpi.component";
import { SelectWitnessComponent } from "./report-kpi/select-witness/select-witness.component";
import { MediaClientComponent } from "./media-client/media-client.component";
import { EditCreateMediaClientsComponent } from "./media-client/edit-create-media-clients/edit-create-media-clients.component";
import { MediaClientsService } from "../../../services/media-clients.service";

@NgModule({
	declarations: [
		PublicidadComponent,
		SvsEditCreateComponent,
		MediaComponent,
		EditCreateMediaComponent,
		ReelsComponent,
		CreateEditReelComponent,
		ConfigMediasComponent,
		GroupsComponent,
		UnitsComponent,
		EditCreateUnitsComponent,
		EditCreateGroupsComponent,
		ConfigGroupsComponent,
		ReelCategoriesComponent,
		CreateEditReelCategoryComponent,
		ShowVideoComponent,
		EvidencesComponent,
		UnitEvidencesComponent,
		LayoutsComponent,
		CreateEditLayoutComponent,
		ImportReelComponent,
		ExportReportComponent,
		UsersComponent,
		CreateEditUserComponent,
		ClientModalComponent,
		MediaKpiComponent,
		HerramientasComponent,
		ReportKpiComponent,
		SelectWitnessComponent,
		MediaClientComponent,
		EditCreateMediaClientsComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RxReactiveFormsModule,
		RxReactiveDynamicFormsModule,
		SharedModule,
		SvsRoutingModule,
		DataViewModule,
		ButtonModule,
		PickListModule,
		ImageModule,
		GalleriaModule,
		PaginatorModule,
		CalendarModule,
		InputSwitchModule,
		TooltipModule,
		FileUploadModule,
		ChartsModule,
	],
	providers: [
		FormService,
		MediasService,
		ReelsService,
		GroupsService,
		DialogService,
		LayoutsService,
		MediaClientsService
	],
})
export class SvsModule {}
